import React from 'react';
import {
  Badge, Box, Heading, HStack, Icon, Text, useColorModeValue,
  Spacer,
} from '@chakra-ui/react';
import { FiMessageSquare } from 'react-icons/fi';
import GlassCard from '../GlassCard';
import ChatPanel from '../ChatPanel';
import { TEAM_THREAD_KEY } from '../../hooks/useChat';
import { useChatUnread } from '../../hooks/useChatRead';
import SlackLinkButton from '../SlackLinkButton';
import ChatFocusControls from '../ChatFocusControls';

// item 217 — the global TEAM CHAT on the dashboard, tied to the Sales Bible. One shared
// company-wide thread open to ALL roles (the company↔accountant thread and per-project
// threads stay separate). Permissions are allow-all for MVP, so every authenticated user
// can read + post here. Reuses the shared ChatPanel scoped to the TEAM thread.
const TeamChatCard: React.FC = () => {
  const { unreadCount } = useChatUnread(TEAM_THREAD_KEY);
  const subColor = useColorModeValue('gray.600', 'whiteAlpha.700');

  return (
    <GlassCard p={{ base: 4, md: 6 }}>
      {/* item 1183 dart#1 (Chad, mobile) — the header WRAPS: title + Slack + Focus/Undock
          can't fit one row at phone width; nowrap punched through the card and dragged the
          whole page wide (the clipped ⤢). */}
      <HStack spacing={2} mb={1} flexWrap="wrap" sx={{ rowGap: '6px' }}>
        <Icon as={FiMessageSquare} />
        <Heading size="sm">GLOBAL TALK</Heading>
        {unreadCount > 0 && (
          <Badge colorScheme="green" borderRadius="full" px={2}>{`${unreadCount} new`}</Badge>
        )}
        <Spacer />
        {/* item 379 — two-way Slack link for the whole-team channel (one-time) */}
        <SlackLinkButton threadKey={TEAM_THREAD_KEY} suggestedName="basix-global-talk" />
        <ChatFocusControls threadKey={TEAM_THREAD_KEY} title="Global Talk" />
      </HStack>
      <Text fontSize="sm" color={subColor} mb={4}>
        One shared channel for the whole team — talk through deals and jobs alongside the
        Sales Bible. Everyone can read and post; messages are append-only.
      </Text>
      <ChatPanel threadKey={TEAM_THREAD_KEY} />
    </GlassCard>
  );
};

export default TeamChatCard;
